export default __webpack_public_path__ + "static/media/940 air cargo logo.f63043dc.png";